import { validate } from '../../services/validation';
import { applyFormOverrides } from '../../services/form-overrides';
import { applyNestedForms } from '../../services/apply-nested-forms';
import { applyOverrides } from '@wix/form-conditions';
import { applyNestedFormOverrides } from '@wix/nested-form-overrides';
export const validateForm = (formsById, addressTemplates, validationMode) => ({ formId, values, overrides }) => {
    const form = formsById[formId];
    if (!form) {
        console.error('Trying to validate a form that does not exist');
        return;
    }
    const formWithOverrides = applyNestedForms(applyFormOverrides(applyNestedFormOverrides(applyOverrides(form, values)), overrides ?? {}));
    return validate(formWithOverrides, values, addressTemplates, validationMode);
};
//# sourceMappingURL=validate-form.js.map